<div>
  <ng-container *ngIf="show$ | async; else noPermissionContent">
    <ng-content></ng-content>
  </ng-container>
  <ng-template #noPermissionContent>
    <ng-content select="[none-permission]"></ng-content>
  </ng-template>
</div>
